// extracted by css-extract-rspack-plugin
export default {"textarea":"RemindModal__textarea--gNsxn"};